import { useCallback } from 'react'
import { useWeb3React } from '@web3-react/core'
import { useAppDispatch } from 'state'
import { updateUserStakedBalance, updateUserBalance } from 'state/actions'
import { stakeFarm } from 'utils/calls'
import { BIG_TEN } from 'utils/bigNumber'
import { useMasterchef } from 'hooks/useContract'

const useStakePool = (sousId: number) => {
  const dispatch = useAppDispatch()
  const { account } = useWeb3React()
  const masterChefContract = useMasterchef()

  const handleStake = useCallback(
    async (amount: string, decimals = 18) => {
      await stakeFarm(masterChefContract, sousId, amount, BIG_TEN.pow(decimals))
      dispatch(updateUserStakedBalance(sousId, account))
      dispatch(updateUserBalance(sousId, account))
    },
    [account, dispatch, masterChefContract, sousId],
  )

  return { onStake: handleStake }
}

export default useStakePool
